import CascaderPanel from './panel';

/* istanbul ignore next */
CascaderPanel.install = function(Vue) {
  Vue.component(CascaderPanel.name, CascaderPanel);
};

export default CascaderPanel;


// WEBPACK FOOTER //
// ./src/components/framework/cascader/panel/index.js